import React from 'react';
import { Button } from 'react-bootstrap';

const DuplicateOfferModal = ({
    showDuplicateModal,
    duplicateOffers,
    duplicateResolutions,
    setDuplicateResolutions,
    handleConfirmDuplicateResolutions,
    setShowDuplicateModal,
    setDuplicateOffers
}) => {
    if (!showDuplicateModal) return null;

    return (
        <div className="duplicate-modal-overlay">
            <div className="duplicate-modal-container">
                <h3>Duplicate Offers Found</h3>
                <p className="warning_popup_footer" style={{textAlign: 'left'}}>The following offers have duplicates for some dates. Please choose an action for each duplicate date:</p>
                
                {duplicateOffers.map((duplicate, offerIndex) => {
                    const offerResolutions = duplicateResolutions[offerIndex] || {};
                    
                    return (
                        <div  key={offerIndex} className="duplicate-offer-card">
                            <div className="duplicate-offer-details">
                                <h4 className="duplicate-offer-header">Offer Details</h4>
                                <strong>Time:</strong> {duplicate.newOffer.startTime} - {duplicate.newOffer.endTime}<br/>
                                <strong>Classification:</strong> {duplicate.newOffer.classification}<br/>
                                <strong>Duty Assignment:</strong> {duplicate.newOffer.dutyAssignment}<br/>
                                
                                {duplicate.nonDuplicateDates.length > 0 && (
                                    <div className="duplicate-description-text">
                                        <strong>Will be created for dates:</strong> {duplicate.nonDuplicateDates.join(', ')}
                                    </div>
                                )}
                            </div>
                            
                            <h5 className="duplicate-red-text" style={{marginBottom: '15px'}}>Duplicate(s):</h5>
                            
                            {duplicate.duplicateDates.map((duplicateDate, dateIndex) => {
                                const resolution = offerResolutions[duplicateDate.date] || { action: null, additionalSlots: 1 };
                                const currentSlots = duplicateDate.existingOffer.slots || 0;
                                const newTotalSlots = currentSlots + resolution.additionalSlots;
                                
                                return (
                                    <div key={dateIndex} className={`duplicate-date-item ${resolution.action ? 'resolved' : ''}`}>
                                        <div style={{marginBottom: '10px'}}>
                                            <strong>Date:</strong> {duplicateDate.date}<br/>
                                            <strong>Existing Offer ID:</strong> {duplicateDate.existingOffer.offerId}<br/>
                                            <strong>Current Slots:</strong> {duplicateDate.existingOffer.slots || 'N/A'}
                                        </div>
                                        
                                        {!resolution.action ? (
                                            <div className="duplicate-button-group">
                                                <Button 
                                                    onClick={() => {
                                                        setDuplicateResolutions(prev => ({
                                                            ...prev,
                                                            [offerIndex]: {
                                                                ...prev[offerIndex],
                                                                [duplicateDate.date]: { 
                                                                    ...prev[offerIndex][duplicateDate.date], 
                                                                    action: 'addSlots' 
                                                                }
                                                            }
                                                        }));
                                                    }}
                                                    className="button-regular duplicate-button-green"
                                                    size="sm"
                                                >
                                                    Add Slots
                                                </Button>
                                                <Button 
                                                    onClick={() => {
                                                        setDuplicateResolutions(prev => ({
                                                            ...prev,
                                                            [offerIndex]: {
                                                                ...prev[offerIndex],
                                                                [duplicateDate.date]: { 
                                                                    ...prev[offerIndex][duplicateDate.date], 
                                                                    action: 'createDuplicate' 
                                                                }
                                                            }
                                                        }));
                                                    }}
                                                    className="button-regular duplicate-button-blue"
                                                    size="sm"
                                                >
                                                    Create Duplicate
                                                </Button>
                                            </div>
                                        ) : resolution.action === 'addSlots' ? (
                                            <div className="duplicate-add-slots">
                                                <div className="duplicate-resolution-header">
                                                    <strong className="duplicate-green-text">Adding Slots to Existing Offer</strong>
                                                    <button 
                                                        onClick={() => {
                                                            setDuplicateResolutions(prev => ({
                                                                ...prev,
                                                                [offerIndex]: {
                                                                    ...prev[offerIndex],
                                                                    [duplicateDate.date]: { 
                                                                        ...prev[offerIndex][duplicateDate.date], 
                                                                        action: null 
                                                                    }
                                                                }
                                                            }));
                                                        }}
                                                        className="duplicate-close-button"
                                                    >
                                                        ×
                                                    </button>
                                                </div>
                                                <div style={{marginBottom: '10px'}}>
                                                    <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>
                                                        Additional Slots to Add:
                                                    </label>
                                                    <input 
                                                        type="number" 
                                                        min="1" 
                                                        max="99"
                                                        value={resolution.additionalSlots}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10) || 1;
                                                            if (value >= 1 && value <= 99 && (currentSlots + value) <= 99) {
                                                                setDuplicateResolutions(prev => ({
                                                                    ...prev,
                                                                    [offerIndex]: {
                                                                        ...prev[offerIndex],
                                                                        [duplicateDate.date]: { 
                                                                            ...prev[offerIndex][duplicateDate.date], 
                                                                            additionalSlots: value 
                                                                        }
                                                                    }
                                                                }));
                                                            }
                                                        }}
                                                        className="duplicate-slots-input"
                                                    />
                                                    <span className="duplicate-slots-hint">
                                                        New Total: {newTotalSlots} slots
                                                    </span>
                                                </div>
                                                {newTotalSlots > 99 && (
                                                    <p className="duplicate-error-text">
                                                        *Total slots cannot exceed 99
                                                    </p>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="duplicate-create-duplicate">
                                                <div className="duplicate-resolution-header">
                                                    <strong className="duplicate-blue-text">Will Create Duplicate Offer for {duplicateDate.date}</strong>
                                                    <button 
                                                        onClick={() => {
                                                            setDuplicateResolutions(prev => ({
                                                                ...prev,
                                                                [offerIndex]: {
                                                                    ...prev[offerIndex],
                                                                    [duplicateDate.date]: { 
                                                                        ...prev[offerIndex][duplicateDate.date], 
                                                                        action: null 
                                                                    }
                                                                }
                                                            }));
                                                        }}
                                                        className="duplicate-close-button"
                                                    >
                                                        ×
                                                    </button>
                                                </div>
                                                <p className="duplicate-description-text">
                                                    This offer will be created as a duplicate of the existing offer for this date.
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
                
                <div className="duplicate-actions-container">
                    <Button 
                        onClick={() => {
                            const allResolved = duplicateOffers.every(duplicate => 
                                duplicate.duplicateDates.every(dupDate => {
                                    const offerResolutions = duplicateResolutions[duplicateOffers.indexOf(duplicate)] || {};
                                    const resolution = offerResolutions[dupDate.date];
                                    return resolution && resolution.action !== null;
                                })
                            );
                            
                            const validSlots = duplicateOffers.every(duplicate => 
                                duplicate.duplicateDates.every(dupDate => {
                                    const offerResolutions = duplicateResolutions[duplicateOffers.indexOf(duplicate)] || {};
                                    const resolution = offerResolutions[dupDate.date];
                                    if (resolution?.action === 'addSlots') {
                                        const currentSlots = dupDate.existingOffer.slots || 0;
                                        return (currentSlots + resolution.additionalSlots) <= 99;
                                    }
                                    return true;
                                })
                            );
                            
                            if (!allResolved) {
                                alert('Please choose an action for each duplicate date.');
                                return;
                            }
                            
                            if (!validSlots) {
                                alert('Please ensure all slot totals are 99 or less.');
                                return;
                            }
                            
                            handleConfirmDuplicateResolutions();
                        }}
                        className="button-regular duplicate-button-confirm"
                        disabled={!duplicateOffers.every(duplicate => 
                            duplicate.duplicateDates.every(dupDate => {
                                const offerResolutions = duplicateResolutions[duplicateOffers.indexOf(duplicate)] || {};
                                const resolution = offerResolutions[dupDate.date];
                                return resolution && resolution.action !== null;
                            })
                        )}
                    >
                        CONFIRM ALL ACTIONS
                    </Button>
                    <Button 
                        onClick={() => {
                            setShowDuplicateModal(false);
                            setDuplicateOffers([]);
                            setDuplicateResolutions({});
                        }}
                        className="button-regular duplicate-button-cancel"
                    >
                        CANCEL
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default DuplicateOfferModal;
